import request from './index';

export function getStockSearch(searchText) {
  return request({
    url: '/kr/stock/search/' + searchText,
    method: 'get'
  })
}

export function getDefaultStock() {
  return request({
    url: '/kr/stock',
    method: 'get'
  })
}

export function getStock(ticker) {
  return request({
    url: '/kr/stock/' + ticker,
    method: 'get'
  })
}

export function getStockHowto(data) {
  return request({
    url: '/kr/stock/howto',
    method: 'get',
    params: data
  })
}

export function getStockSeason(data) {
  return request({
    url: '/kr/stock/season',
    method: 'get',
    params: data
  })
}

export function getRelativeRate(ticker) {
  return request({
    url: '/kr/stock/relative-rate/' + ticker,
    method: 'get'
  })
}

export function getFinancialStatements(data) {
  return request({
    url: '/kr/stock/financial-statements',
    method: 'get',
    params: data
  })
}
